import BkwFrame from './components/Frame';

interface BkwEnergyCalculatorProps {
    src: string;
}

const BkwEnergyCalculator = ({ src }: BkwEnergyCalculatorProps) => {
    return <BkwFrame src={src}></BkwFrame>;
};

export default BkwEnergyCalculator;
